var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.25 9.87v1.75a1.166 1.166 0 0 1-1.272 1.167 11.55 11.55 0 0 1-5.034-1.791 11.4 11.4 0 0 1-3.5-3.5 11.54 11.54 0 0 1-1.79-5.058 1.167 1.167 0 0 1 1.16-1.271h1.75A1.17 1.17 0 0 1 4.731 2.17c.074.56.21 1.11.408 1.64.16.425.058.906-.262 1.23l-.741.74a9.33 9.33 0 0 0 3.5 3.5l.74-.74c.324-.32.805-.423 1.231-.263.53.198 1.08.335 1.64.409A1.167 1.167 0 0 1 12.25 9.87",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;